import React, { useContext, useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { useWellManagedCategoriesContext } from 'contexts/CategoryInsightsKpi/WellManagedCategoriesProvider';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const WellManagedCategoriesExplore = () => {
	const { gridData } = useWellManagedCategoriesContext();
	const { wellmanaged, vendorCountMin } = useContext(
		CategoryInsightsSettingsContext
	);

	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of categories where top ${vendorCountMin} vendors cover more than ${wellmanaged}% of category spend.`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default WellManagedCategoriesExplore;
